import React from 'react';

const EllipsisIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <defs>
                <linearGradient id="dotsGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#2D2D2D">
                        <animate attributeName="offset" values="0;1;0" dur="2s" repeatCount="indefinite" />
                    </stop>
                    <stop offset="50%" stopColor="#7D889F" />
                    <stop offset="100%" stopColor="#4B5974">
                        <animate attributeName="offset" values="1;0;1" dur="2s" repeatCount="indefinite" />
                    </stop>
                </linearGradient>
            </defs>

            <path
                d="M2.33333 10.8337C2.79357 10.8337 3.16667 10.4606 3.16667 10.0003C3.16667 9.54009 2.79357 9.16699 2.33333 9.16699C1.8731 9.16699 1.5 9.54009 1.5 10.0003C1.5 10.4606 1.8731 10.8337 2.33333 10.8337Z"
                fill="url(#dotsGradient)"
                stroke="url(#dotsGradient)"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 10.8337C10.4603 10.8337 10.8334 10.4606 10.8334 10.0003C10.8334 9.54009 10.4603 9.16699 10 9.16699C9.53978 9.16699 9.16669 9.54009 9.16669 10.0003C9.16669 10.4606 9.53978 10.8337 10 10.8337Z"
                fill="url(#dotsGradient)"
                stroke="url(#dotsGradient)"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.6666 10.8337C18.1269 10.8337 18.5 10.4606 18.5 10.0003C18.5 9.54009 18.1269 9.16699 17.6666 9.16699C17.2064 9.16699 16.8333 9.54009 16.8333 10.0003C16.8333 10.4606 17.2064 10.8337 17.6666 10.8337Z"
                fill="url(#dotsGradient)"
                stroke="url(#dotsGradient)"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default EllipsisIcon;
